import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import GlobalTheme from '../../../styled/GlobalTheme';

const Container = styled.div`
  height: 5px;
  display: grid;
  grid-template-columns: 1fr 15px 1fr;
  grid-column-gap: 6px;
  margin: 5% 25% 7% 25%;

  ${GlobalTheme.breakpoints.up('sm')}{
    margin: 5% 0 7% 0;
  }
  ${({ isApp }) => isApp && `
    grid-template-columns: 100%;
  `}
`;
const Stroke = styled.div`
  border-top: 1px solid #909090;
  margin: 10px 0;
  ${({ isApp }) => isApp && `
    display: none;
  `}
`;
const Paragraph = styled.p`
  margin: 0;
  font-size: 12px;
  text-align: center;
  ${({ isApp, theme }) => isApp && `
    color: ${theme.colors.white};
    font-size: 16px;
    font-weight: 600;
    position: relative;
    text-transform: capitalize;
    &::after {
      content: ":";
    }
  `}
`;

const StrokeBox = ({ isApp }) => (
  <Container isApp={isApp}>
    <Stroke isApp={isApp} />
    <Paragraph isApp={isApp}>
      <FormattedMessage
        id="k.or"
        defaultMessage="or"
      />
    </Paragraph>
    <Stroke isApp={isApp} />
  </Container>
);

StrokeBox.propTypes = {
  isApp: PropTypes.bool,
};

StrokeBox.defaultProps = {
  isApp: false,
};

export default StrokeBox;
